import Head from 'next/head';
import 'animate.css';
import preview from '../../public/preview/preview-healthcare.jpg';
import { Footer, Header } from '../../components';
import Healthcare from './healthcare';
import menu from '../../utils/menu';

export default function HealthcarePage() {
  return (
    <>
      <Head>
        <title>
          Mavinx Healthcare Solutions: Innovating the Healthcare Industry
        </title>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin=""
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Cairo:wght@300;500;600&family=Nunito&family=Open+Sans:wght@600&family=Prompt:wght@500&display=swap"
          rel="stylesheet"
        />

        <meta
          property="og:title"
          content="Mavinx Healthcare Solutions: Innovating the Healthcare Industry"
        />
        <meta property="og:image" content={`${preview.src}`} />
        <meta name="twitter:image" content={`${preview.src}`} />
        <meta
          property="og:image:alt"
          content="Mavinx Healthcare Solutions: Innovating the Healthcare Industry"
        />
        <meta property="og:type" content="product" />
        <meta
          property="og:description"
          content="Mavinx transforms healthcare with new technologies and customized solutions. Discover how our experience in healthcare software development, telemedicine platforms, EHRs, and health mobile apps can improve patient care, operational efficiency, and healthcare delivery. Discover how our healthcare solutions improve processes, data security, remote patient monitoring, and patient engagement. Mavinx can help you transform healthcare with technology."
        />
        <meta
          name="description"
          content="Mavinx transforms healthcare with new technologies and customized solutions. Discover how our experience in healthcare software development, telemedicine platforms, EHRs, and health mobile apps can improve patient care, operational efficiency, and healthcare delivery. Discover how our healthcare solutions improve processes, data security, remote patient monitoring, and patient engagement. Mavinx can help you transform healthcare with technology."
        />
        <meta
          name="keywords"
          content="healthcare solutions, Mavinx healthcare, healthcare industry, healthcare software development, telemedicine platforms, electronic health records, health mobile applications, healthcare delivery, patient care, operational efficiency, streamlined workflows, secure data management, remote patient monitoring, patient engagement, technology in healthcare, Mavinx healthcare solutions"
        />
      </Head>
      <Header
        appearance="transparent"
        appearanceLogo="healthCase"
        appearanceNav="healthCase"
        menu={menu}
      />
      <Healthcare />
      <Footer line="white" logo="white" variant="healthCase" />
    </>
  );
}
